import {
    InfoBarMessageRank,
    InfoBarMessageColor,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

/**
 * get infobar icon color based on rank and color
 * Note: provided color is only applicable when rank is Safety or Translation
 */
const getInfoBarIconColor = (rank: InfoBarMessageRank, color?: InfoBarMessageColor) => {
    switch (rank) {
        case InfoBarMessageRank.Error:
            return {
                error: true,
            };
        case InfoBarMessageRank.Translation:
        case InfoBarMessageRank.Safety:
            return {
                red: color == InfoBarMessageColor.Red,
                green: color == InfoBarMessageColor.Green,
                yellow: color == InfoBarMessageColor.Yellow,
                orange: color == InfoBarMessageColor.Orange,
            };
        default:
            return null;
    }
};

export default getInfoBarIconColor;
